module.exports = __webpack_public_path__ + "static/media/change-product-format.4f3c86b0.jpg";